export default __webpack_public_path__ + "static/media/host_hold.c38aaf11.svg";